// React
import React from 'react';

// Packages
import cc from 'classcat';
import t from 'prop-types';
import { useController } from 'react-hook-form';

// Utilities
import { s3 } from 'utilities/api';

// Components
import Button from 'components/button';

const AttachComponent = ({
    name,
    label,
    defaultValue,
    accept,
    controller,
    type,
    onClick,
    setAttachLoading,
    setAttachProgress,
    ...rest
}) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const {
        field: { onChange, value, ref },
        fieldState: { error },
    } = useController({
        name,
        control: controller,
    });

    // ///////////////////
    // METHODS
    // ///////////////////

    async function uploadFile(event) {
        if (event.target.files.length > 0) {
            setAttachLoading(true);
            const file = event.target.files[0];
            if (file.size > 199999999) {
                alert('File size should be under 200 mb');
            } else {
                try {
                    // Get signed url
                    const signedUrl = await s3.getSignedUrl(file);

                    // Upload
                    await s3.uploadFileWithSignedUrl(
                        file,
                        signedUrl,
                        setAttachProgress
                    );
                    onChange(signedUrl.split('?')[0] ?? 'no-url-defined');
                    onClick();
                } catch (error) {
                    console.log(error);
                }
            }
            setAttachLoading(false);
            setAttachProgress(null);
        }
    }

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <label className="flex flex-col" htmlFor={name}>
            <Button
                variant="secondary"
                className="self-start mt-16"
                action={'fake'}>
                {label}
            </Button>
            <input
                ref={ref}
                id={name}
                type="file"
                accept={accept}
                onChange={event => {
                    uploadFile(event);
                }}
                defaultValue={''}
                className={cc([
                    'input-defaults input-defaults-teal hidden',
                    {
                        'input-defaults-error': error,
                        'mt-16': label,
                    },
                ])}
                {...rest}
            />
        </label>
    );
};

AttachComponent.propTypes = {
    accept: t.string,
    type: t.oneOf(['video', 'image', 'document']).isRequired,
};

AttachComponent.defaultProps = {
    accept: '.png,.jpg,.jpeg',
    type: 'image',
};

export default AttachComponent;
